import React from 'react';
import axios from 'axios';
import gtm from 'general/js/gtm';
import { mockWeatherData } from './mock-weather-data';

class WeatherWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            weatherData: null,
            view: 'today'
        };

        this.useMock = false;
        this.init();
    }

    init() {
        const { options } = this.props;

        const fetchFn = this.useMock ?
            this.fetchMockData :
            () => this.fetchData(options);

        fetchFn().then((data) => {
            this.setState({ weatherData: data });
        });
    }

    fetchMockData = () => {
        return Promise.resolve(mockWeatherData);
    };

    fetchData = (options) => {
        return axios
            .get(options.weatherApiEndpoint, {
                timeout: 60000,
            })
            .then((result) => {
                this.lastRequestCancel = null;
                return result.data;
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                    this.lastRequestCancel = null;
                }
                return Promise.reject(error);
            });
    };

    handleToggle = () => {
        this.setState((prevState) => ({
            view: prevState.view === 'today' ? 'week' : 'today'
        }));
    };

    onClickLink = (weatherLinkText) => {
        gtm.push('Weather Widget', 'Button Click', weatherLinkText);
    };

    renderForecastItem = (forecast) => {
        const {
            dateTimeText,
            maxTemperature,
            windSpeedMph,
            weatherCode
        } = forecast;

        return (
            <li key={dateTimeText} className="weather__forecast-col">
                <span className="weather__day-hour">{dateTimeText}</span>
                <svg className="weather__icon" width="30" height="30" focusable="false">
                    <use xlinkHref={`#icon-weather-${weatherCode}`}></use>
                </svg>
                <span className="weather__temperature">{maxTemperature}<span>°C</span></span>
                <div className="weather__wind">
                    <svg aria-label="wind details" className="weather__wind--icon" width="12" height="12" focusable="false">
                        <use xlinkHref="#icon-weather-wind"></use>
                    </svg>
                    <span>{windSpeedMph}</span>
                </div>
            </li>
        );
    };

    render() {
        const { weatherData, view } = this.state;
        const { options } = this.props;

        if (!weatherData) return <div>Loading...</div>;

        const {
            locationName,
            currentHourlyForecast,
            hourly,
            daily
        } = weatherData;

        const isToday = view === 'today';

        return (
            <div className="weather-widget-container">
                <div className="current-forecast">
                    <div className="current-forecast__highlight">
                        <div className="current-forecast__info">
                            <svg aria-label="temperature value" className="current-forecast__highlight--icon" width="48" height="49" focusable="false">
                                <use xlinkHref={`#icon-weather-${currentHourlyForecast.weatherCode}`}></use>
                            </svg>
                            <span className="current-forecast__highlight--temparature">{currentHourlyForecast.maxTemperature}<strong>°C</strong></span>
                        </div>
                        <h2 className="current-forecast__title">{locationName}</h2>
                    </div>
                    <div className="current-forecast__details">
                        <div className="current-forecast__info">
                            <svg aria-label="rain quantity" className="weather__icon" width="30" height="30" focusable="false">
                                <use xlinkHref="#icon-weather-rain"></use>
                            </svg>
                            <div className="current-forecast__values">
                                <span>{currentHourlyForecast.probabilityOfPrecipitation}%</span>
                                <span>{currentHourlyForecast.totalPrecipitationAmount} mm</span>
                            </div>
                        </div>
                        <div className="current-forecast__info">
                            <svg aria-label="wind details" className="weather__icon" width="30" height="30" focusable="false">
                                <use xlinkHref="#icon-weather-wind"></use>
                            </svg>
                            <div className="current-forecast__values">
                                <span>{currentHourlyForecast.windSpeedMph} mph</span>
                                <span>{currentHourlyForecast.windDisplayDirection}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="forecast-list">
                    <ul className="weather__forecast-row">
                        {(isToday ? hourly : daily).map(this.renderForecastItem)}
                    </ul>
                </div>
                <div className="weather-controls">
                    <div className="weather-toggle">
                        <button
                            type="button"
                            aria-label="todays weather button"
                            className={`toggle-btn ${view === 'today' ? 'active' : ''}`}
                            onClick={() => this.setState({ view: 'today' })}>Today
                        </button>
                        <button
                            type="button"
                            aria-label="weeks weather button"
                            className={`toggle-btn ${view === 'week' ? 'active' : ''}`}
                            onClick={() => this.setState({ view: 'week' })}>Week
                        </button>
                    </div>
                    {options.weatherLinkText && options.weatherLinkUrl && (
                        <a
                            href={options.weatherLinkUrl}
                            onClick={() => this.onClickLink(options.weatherLinkText)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="weather-link">
                            {options.weatherLinkText}
                        </a>
                    )}
                </div>
            </div>
        );
    }
}

export default WeatherWidget;
